import {Box, Grid} from "@mui/system";
import style from "../../assets/css/proposal.module.scss";
import {Link, useNavigate} from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
} from "@mui/material";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useMemo, useState} from "react";
import {HiCurrencyDollar} from "react-icons/hi2";
import {SlRefresh} from "react-icons/sl";
import GlobalDateField from "../global-fields/GlobalDateField";
import GlobalTextField from "../global-fields/GlobalTextField";
import GlobalSelectField from "../global-fields/GlobalSelectField";
import GlobalModal from "../global-fields/GlobalModal";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState} from "../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";
import {SiAdobeacrobatreader} from "react-icons/si";
import {ERR_MESSAGE, MANDATORY_QUES} from "../../constants/constants";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {
  handleFileUploadWithoutVids,
  normalizeCurrencyToNumber,
  parseToNumber,
  removeCookies,
  USD_FORMATTER,
} from "../../constants/helper";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {REQUEST_CLAIM} from "../../constants/apiConstant";
import GlobalTextAriaField from "../global-fields/GlobalTextArea";
import dayjs from "dayjs";
import {useEffect} from "react";
import {amountSchemaWithRequiredGreaterThanZero} from "../../constants/validationSchemas";
import styled from "styled-components";
import {FaExternalLinkAlt} from "react-icons/fa";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import GlobalErrorMsgBox from "../global-fields/GlobalErrorMsgBox";

const LossTypeMenuItems = [
  {name: "Mysterious Disappearance", value: "Mysterious Disappearance"},
  {name: "⁠Shipping", value: "⁠Shipping"},
  {name: "⁠Travel", value: "⁠Travel"},
  {name: "⁠Burglary", value: "⁠Burglary"},
  {name: "⁠Robbery", value: "⁠Robbery"},
  {name: "Other", value: "Other"},
];

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const ClaimFormModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user} = useSelector(selectAuthState);
  const {claimFormParentData} = useSelector(selectDataStoreState);
  const {claimFormModal} = useSelector(selectUiState);
  // console.log("A", claimFormModal, claimFormParentData)
  const initialValues = {
    date_reported: "",
    loss_date: "",
    estimated_loss_amount: "",
    loss_type: "",
    reason: "",
    attachment: null,
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      date_reported: Yup.string().required(MANDATORY_QUES),
      loss_date: Yup.string().required(MANDATORY_QUES),
      estimated_loss_amount: amountSchemaWithRequiredGreaterThanZero,
      loss_type: Yup.string().required(MANDATORY_QUES),
      reason: Yup.string().when("loss_type", {
        is: "Other",
        then: (schema) => schema.required(MANDATORY_QUES),
        otherwise: (schema) => schema.notRequired(),
      }),
      attachment: Yup.mixed()
        .nullable()
        .test("file-or-url", MANDATORY_QUES, (value) => {
          if (!value) return true; // No Validation
          // if (!value) return false; // If value is null/undefined, it's invalid
          if (typeof value === "string" && value.includes("https://"))
            return true; // Valid URL
          if (value instanceof File) return true; // Valid File
          return false; // Invalid case
        }),
    }),

    onSubmit: async (values, {resetForm}) => {
      dispatch(setUiData({showLoader: true}));
      let data = {
        ...values,
        date_reported: dayjs(values?.date_reported).format("MM-DD-YYYY"),
        loss_date: dayjs(values?.loss_date).format("MM-DD-YYYY"),
        estimated_loss_amount: normalizeCurrencyToNumber(
          values.estimated_loss_amount
        ),
        proposal_id: claimFormParentData?.proposal_id,
        ...(user?.user_type === "agent"
          ? {user_id: claimFormParentData.user_id, agent_id: user.id}
          : {user_id: user.id}),
      };
      // console.log("CALIM data:", data);
      // dispatch(setUiData({ showLoader: false }));
      // return;

      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const options = {
        method: REQUEST_CLAIM.method,
        body: formData,
      };

      try {
        const response = await fetch(REQUEST_CLAIM.url, options);
        const res = await response.json();
        dispatch(setUiData({showLoader: false}));
        if (res.status == 1) {
          GlobalNotificationPopup({type: "success", message: res?.message});
          // resetForm();
        } else {
          GlobalNotificationPopup({type: "error", message: res?.message});
        }
        handleCloseClaimForm();
      } catch (error) {
        console.error("Error:", error);
        handleCloseClaimForm();
        removeCookies("isLogin");
        dispatch(setUiData({showLoader: false}));
        GlobalNotificationPopup({
          type: "error",
          message: ERR_MESSAGE,
        });
        navigate("/");
      }
    },
  });

  const handleCloseClaimForm = () => {
    formik.resetForm();
    dispatch(
      setDataStore({
        claimFormParentData: null,
      })
    );
    dispatch(
      setUiData({
        claimFormModal: false,
      })
    );
  };

  const handleAmountFieldChange = (e, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Parse numeric part
    const numericValue = parseToNumber(rawValue);

    // If user typed only "$" or "$.", allow typing to continue
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));
      if (decimalPart !== undefined) {
        // Limit decimal to 2 digits
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);

    // Remove the setTimeout — Formik validation schema will handle greater-than-zero error
  };

  return (
    <>
      <GlobalModal
        open={claimFormModal}
        handleClose={() => {
          formik.resetForm();
          handleCloseClaimForm();
        }}
        aria-labelledby="claim-history"
        closeIcon={true}
        title={"Claim Form"}
        subtitle={`Policy Number: ${claimFormParentData?.policy_number}`}
        dialogTitleClass={style.claimPopTitle}
        // disableBackdropClick={true}
        dialogContent={
          <Grid container spacing={2}>
            <Grid size={{xs: 12, md: 12}} className={style.claimPopMain}>
              <form
                autoComplete="false"
                autoSave="false"
                onSubmit={formik.handleSubmit}
              >
                {" "}
                <Grid container spacing={2}>
                  <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{mb: 1, color: "#000"}}>Date of Loss*</Box>
                    <GlobalDateField
                      name={`loss_date`}
                      value={formik.values.loss_date}
                      onChange={(newValue) =>
                        formik.setFieldValue(`loss_date`, newValue)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.loss_date &&
                        Boolean(formik.errors?.loss_date)
                      }
                      helperText={
                        formik.touched?.loss_date && formik.errors?.loss_date
                      }
                      disablePast={false}
                      disableFuture={true}
                      clearBtn={formik.values.loss_date !== ""}
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{mb: 1, color: "#000"}}>Date Reported*</Box>
                    <GlobalDateField
                      name={`date_reported`}
                      value={formik.values.date_reported}
                      onChange={(newValue) =>
                        formik.setFieldValue(`date_reported`, newValue)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.date_reported &&
                        Boolean(formik.errors?.date_reported)
                      }
                      helperText={
                        formik.touched?.date_reported &&
                        formik.errors?.date_reported
                      }
                      disablePast={false}
                      disableFuture={false}
                      dependentMinValue={dayjs(
                        formik.values.loss_date
                      ).subtract(1, "day")}
                      // dependentMinValue={formik.values.loss_date}
                      clearBtn={formik.values.date_reported !== ""}
                    />
                  </Grid>

                  <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{mb: 1, color: "#000"}}>
                      Estimated Loss Amount*
                    </Box>
                    <GlobalTextField
                      placeH="$"
                      type="text"
                      name={`estimated_loss_amount`}
                      id={`_estimated_loss_amount`}
                      value={formik.values?.estimated_loss_amount}
                      //onChange={formik.handleChange}
                      onChange={(e) =>
                        handleAmountFieldChange(e, `estimated_loss_amount`)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.estimated_loss_amount &&
                        Boolean(formik.errors?.estimated_loss_amount)
                      }
                      helperText={
                        formik.touched?.estimated_loss_amount &&
                        formik.errors?.estimated_loss_amount
                      }
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{mb: 1, color: "#000"}}>Type of Loss*</Box>
                    <GlobalSelectField
                      labelId={`loss_type`}
                      value={formik.values?.loss_type}
                      onChange={(e) =>
                        formik.setFieldValue(`loss_type`, e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.loss_type &&
                        Boolean(formik.errors?.loss_type)
                      }
                      helperText={
                        formik.touched?.loss_type
                          ? formik.errors?.loss_type
                          : ""
                      }
                      placeH={"Select"}
                      menuItems={LossTypeMenuItems}
                    />
                  </Grid>
                  <Grid size={{xs: 12, md: 12}}>
                    <Box sx={{mb: 1, color: "#000"}}>
                      Specify Reason if Other
                    </Box>
                    <GlobalTextAriaField
                      row={2}
                      placeH="Type here..."
                      id="reason"
                      name="reason"
                      type="reason"
                      value={formik.values.reason}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.reason && Boolean(formik.errors.reason)
                      }
                      helperText={formik.touched.reason && formik.errors.reason}
                    />
                  </Grid>
                  <Grid
                    size={{xs: 12, md: 12}}
                    className={style.claimFormFileBtn}
                  >
                    <Box sx={{mb: 1, color: "#000"}}>
                      Goods, Product Details/Police Report (if any)
                    </Box>
                    <Button
                      component="label"
                      variant="contained"
                      startIcon={<CloudUploadIcon />}
                    >
                      {formik.values?.attachment?.name ? (
                        `Selected File - ${formik.values?.attachment.name}`
                      ) : formik.values?.attachment?.includes("https://") ? (
                        <span>
                          {`Uploaded File - ${formik.values?.attachment.split("/images/")[1]}`}
                          <span
                            style={{
                              cursor: "pointer",
                              marginLeft: "5px",
                              backgroundColor: "#004F71",
                              borderRadius: "10px",
                              color: "#fff",
                              padding: "3px 5px",
                            }}
                            onClick={() =>
                              window.open(formik.values?.attachment, "_blank")
                            }
                          >
                            VIEW <FaExternalLinkAlt />
                          </span>
                        </span>
                      ) : (
                        "Upload File"
                      )}
                      <VisuallyHiddenInput
                        type="file"
                        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                        // onChange={(event) => {
                        //   formik.setFieldValue(
                        //     `attachment`,
                        //     event.target.files[0]
                        //   );
                        // }}
                        onChange={(event) =>
                          handleFileUploadWithoutVids({
                            event,
                            fieldName: `attachment`,
                            formik,
                            onError: (message) =>
                              GlobalNotificationPopup({type: "error", message}),
                          })
                        }
                      />
                    </Button>
                    {formik.touched?.attachment &&
                    formik?.errors?.attachment ? (
                      <GlobalErrorMsgBox
                        errMessage={formik?.errors?.attachment}
                      />
                    ) : null}
                  </Grid>

                  <Button
                    className={style.claimPopBtn}
                    variant="contained"
                    autoFocus
                    type="submit"
                  >
                    Request Claim
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Grid>
        }
        // dialogActions={
        //   <Button
        //     className={style.claimPopBtn}
        //     variant="contained"
        //     onClick={handleClose}
        //   >
        //     Request Claim
        //   </Button>
        // }
      ></GlobalModal>
    </>
  );
};

export default ClaimFormModal;
